<!-- Error Banner -->
@if (storageState.error && !storageState.loading) {
  <div class="error-banner">
    {{ storageState.error }}
  </div>
}

<!-- Content -->
<div>
  <div class="storage-actions">
    @if (lastRefreshed) {
      <span class="last-refreshed">
        Last refreshed: {{ lastRefreshed | date: 'MM/dd/yyyy h:mm:ss a' }}
      </span>
    }
    <ukg-button
      emphasis="medium"
      size="medium"
      (click)="loadStorageFiles()"
      (keydown.enter)="loadStorageFiles()">
      Refresh
    </ukg-button>
  </div>

  <!-- Empty State -->
  @if (
    !storageState.loading &&
    (!storageState.data ||
      (storageState.data.inputSftpServers.length === 0 &&
        storageState.data.outputSftpServers.length === 0 &&
        storageState.data.objectStorageFolders.length === 0))
  ) {
    <div class="empty-state-centered">
      <p class="empty-state">No storage servers or files configured.</p>
    </div>
  }

  <!-- Content Loaded -->
  @if (storageState.data && storageState.showSection) {
    <div>
      <!-- Input SFTP Servers -->
      @if (
        storageState.data.inputSftpServers.length > 0 ||
        storageState.inputLoading
      ) {
        <div class="storage-section">
          <button class="section-toggle" (click)="toggleSection('input')">
            <span class="section-arrow">{{
              expandedSections.input ? '▼' : '▶'
            }}</span>
            <h2 class="section-title">
              Pro Ingestion ({{ storageState.data.inputSftpServers.length }})
            </h2>
          </button>
          @if (expandedSections.input) {
            <div>
              <!-- Search Input -->
              <ng-container
                *ngTemplateOutlet="
                  searchTemplate;
                  context: { $implicit: 'input' }
                "></ng-container>
              <div class="servers-grid">
                @if (storageState.inputLoading) {
                  <div class="loading-container">
                    <div class="table-wrapper">
                      <table class="data-table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Size</th>
                            <th>Last Modified</th>
                          </tr>
                        </thead>
                        <tbody></tbody>
                      </table>
                    </div>
                    <div class="loading-overlay">
                      <ukg-progress-circular
                        size="small"
                        indeterminate="true"
                        description="Loading input SFTP servers..." />
                    </div>
                  </div>
                }
                @if (!storageState.inputLoading) {
                  <div>
                    @for (
                      server of storageState.data.inputSftpServers;
                      track server
                    ) {
                      <ng-container
                        *ngTemplateOutlet="
                          sftpServerTemplate;
                          context: {
                            $implicit: 'input',
                            server: server,
                            emoji: '📤',
                          }
                        "></ng-container>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
      <!-- Object Storage Folders -->
      @if (
        storageState.data &&
        (storageState.data.objectStorageFolders.length > 0 ||
          storageState.objectStorageLoading)
      ) {
        <div class="storage-section">
          <button
            class="section-toggle"
            (click)="toggleSection('objectStorage')">
            <span class="section-arrow">{{
              expandedSections.objectStorage ? '▼' : '▶'
            }}</span>
            <h2 class="section-title">
              Object Storage ({{
                storageState.data.objectStorageFolders.length
              }})
            </h2>
          </button>
          @if (expandedSections.objectStorage) {
            <div>
              <!-- Search Input -->
              <ng-container
                *ngTemplateOutlet="
                  searchTemplate;
                  context: { $implicit: 'objectStorage' }
                "></ng-container>
              <div class="servers-grid">
                @if (storageState.objectStorageLoading) {
                  <div class="loading-container">
                    <div class="tree-container">
                      <div class="tree-header" [style.padding-left.px]="16">
                        <span style="flex: 1">Name</span>
                        <span>Size</span>
                        <span>Last Modified</span>
                      </div>
                    </div>
                    <div class="loading-overlay">
                      <ukg-progress-circular
                        size="small"
                        indeterminate="true"
                        description="Loading object storage folders..." />
                    </div>
                  </div>
                }
                @if (!storageState.objectStorageLoading) {
                  <div>
                    @for (
                      folder of storageState.data.objectStorageFolders;
                      track folder
                    ) {
                      <div class="result-card">
                        <!-- Folder Header -->
                        <h3>
                          <span class="server-icon">☁️</span>
                          {{ folder.folderPath }}
                        </h3>
                        <!-- Folder Error -->
                        @if (folder.error) {
                          <div class="error-message">
                            <strong>Error:</strong> {{ folder.error }}
                          </div>
                        }
                        <!-- Tree View -->
                        @if (!folder.error) {
                          <div class="tree-container">
                            <!-- Tree Header -->
                            <div
                              class="tree-header"
                              [style.padding-left.px]="16">
                              <span style="flex: 1">Name</span>
                              <span>Size</span>
                              <span>Last Modified</span>
                            </div>
                            <!-- Scrollable rows container -->
                            <div class="tree-rows-wrapper">
                              @if (
                                getFlatTree(
                                  folder.folderPath,
                                  getSearchTerm('objectStorage')
                                ).length === 0
                              ) {
                                <div class="empty-message">No files found</div>
                              }
                              @for (
                                item of getPaginatedFlatTree(
                                  folder.folderPath,
                                  getSearchTerm('objectStorage')
                                );
                                track item
                              ) {
                                <div
                                  class="tree-row"
                                  [class.tree-folder]="item.isFolder"
                                  [class.tree-file]="!item.isFolder"
                                  [style.padding-left.px]="
                                    16 + item.depth * 20
                                  ">
                                  <!-- Folder row -->
                                  @if (item.isFolder) {
                                    <button
                                      class="tree-toggle"
                                      (click)="
                                        toggleTreeNode(
                                          folder.folderPath,
                                          item.nodePath
                                        )
                                      "
                                      (keydown.enter)="
                                        toggleTreeNode(
                                          folder.folderPath,
                                          item.nodePath
                                        )
                                      ">
                                      <span class="tree-arrow">{{
                                        item.isExpanded ? '▼' : '▶'
                                      }}</span>
                                      <span class="tree-icon">📁</span>
                                      <span class="tree-name">{{
                                        item.name
                                      }}</span>
                                    </button>
                                  }
                                  <!-- File row -->
                                  @if (!item.isFolder) {
                                    <span class="tree-icon">📄</span>
                                    <span class="tree-name">{{
                                      item.name
                                    }}</span>
                                    <span class="tree-meta">{{
                                      formatFileSize(item.file!.sizeBytes)
                                    }}</span>
                                    <span class="tree-meta">{{
                                      formatDate(item.file!.lastModified)
                                    }}</span>
                                  }
                                </div>
                              }
                            </div>
                            <!-- Pagination Controls for each Object Storage Folder -->
                            <div class="pagination-container">
                              <div class="page-size-selector">
                                <label
                                  [for]="
                                    'objectStorage-' +
                                    folder.folderPath +
                                    '-page-size'
                                  "
                                  >Rows per page:</label
                                >
                                <select
                                  [id]="
                                    'objectStorage-' +
                                    folder.folderPath +
                                    '-page-size'
                                  "
                                  [value]="
                                    getPaginationState(
                                      'objectStorage',
                                      folder.folderPath
                                    )['pageSize']
                                  "
                                  (change)="
                                    setPageSize(
                                      'objectStorage',
                                      folder.folderPath,
                                      +$any($event.target).value
                                    )
                                  ">
                                  @for (size of PAGE_SIZE_OPTIONS; track size) {
                                    <option [value]="size">
                                      {{ size }}
                                    </option>
                                  }
                                </select>
                              </div>
                              <div class="pagination-info">
                                Page
                                {{
                                  getPaginationState(
                                    'objectStorage',
                                    folder.folderPath
                                  )['currentPage']
                                }}
                                of
                                {{
                                  getTotalPagesForTree(
                                    'objectStorage',
                                    folder.folderPath,
                                    getFlatTree(
                                      folder.folderPath,
                                      getSearchTerm('objectStorage')
                                    )
                                  )
                                }}
                              </div>
                              <div class="pagination-controls">
                                <button
                                  class="pagination-btn"
                                  [disabled]="
                                    !hasPreviousPage(
                                      'objectStorage',
                                      folder.folderPath
                                    )
                                  "
                                  (click)="
                                    goToFirstPage(
                                      'objectStorage',
                                      folder.folderPath
                                    )
                                  "
                                  aria-label="First page">
                                  <ng-container
                                    *ngTemplateOutlet="
                                      firstPageIcon
                                    "></ng-container>
                                </button>
                                <button
                                  class="pagination-btn"
                                  [disabled]="
                                    !hasPreviousPage(
                                      'objectStorage',
                                      folder.folderPath
                                    )
                                  "
                                  (click)="
                                    goToPreviousPage(
                                      'objectStorage',
                                      folder.folderPath
                                    )
                                  "
                                  aria-label="Previous page">
                                  <ng-container
                                    *ngTemplateOutlet="
                                      prevPageIcon
                                    "></ng-container>
                                </button>
                                <button
                                  class="pagination-btn"
                                  [disabled]="
                                    !hasNextPageForTree(
                                      'objectStorage',
                                      folder.folderPath,
                                      getFlatTree(
                                        folder.folderPath,
                                        getSearchTerm('objectStorage')
                                      )
                                    )
                                  "
                                  (click)="
                                    goToNextPageForTree(
                                      'objectStorage',
                                      folder.folderPath,
                                      getFlatTree(
                                        folder.folderPath,
                                        getSearchTerm('objectStorage')
                                      )
                                    )
                                  "
                                  aria-label="Next page">
                                  <ng-container
                                    *ngTemplateOutlet="
                                      nextPageIcon
                                    "></ng-container>
                                </button>
                                <button
                                  class="pagination-btn"
                                  [disabled]="
                                    !hasNextPageForTree(
                                      'objectStorage',
                                      folder.folderPath,
                                      getFlatTree(
                                        folder.folderPath,
                                        getSearchTerm('objectStorage')
                                      )
                                    )
                                  "
                                  (click)="
                                    goToLastPageForTree(
                                      'objectStorage',
                                      folder.folderPath,
                                      getFlatTree(
                                        folder.folderPath,
                                        getSearchTerm('objectStorage')
                                      )
                                    )
                                  "
                                  aria-label="Last page">
                                  <ng-container
                                    *ngTemplateOutlet="
                                      lastPageIcon
                                    "></ng-container>
                                </button>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
      <!-- Output SFTP Servers -->
      @if (
        storageState.data.outputSftpServers.length > 0 ||
        storageState.outputLoading
      ) {
        <div class="storage-section">
          <button class="section-toggle" (click)="toggleSection('output')">
            <span class="section-arrow">{{
              expandedSections.output ? '▼' : '▶'
            }}</span>
            <h2 class="section-title">
              Uluro ({{ storageState.data.outputSftpServers.length }})
            </h2>
          </button>
          @if (expandedSections.output) {
            <div>
              <!-- Search Input -->
              <ng-container
                *ngTemplateOutlet="
                  searchTemplate;
                  context: { $implicit: 'output' }
                "></ng-container>
              <div class="servers-grid">
                @if (storageState.outputLoading) {
                  <div class="loading-container">
                    <div class="table-wrapper">
                      <table class="data-table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Type</th>
                            <th>Size</th>
                            <th>Last Modified</th>
                          </tr>
                        </thead>
                        <tbody></tbody>
                      </table>
                    </div>
                    <div class="loading-overlay">
                      <ukg-progress-circular
                        size="small"
                        indeterminate="true"
                        description="Loading output SFTP servers..." />
                    </div>
                  </div>
                }
                @if (!storageState.outputLoading) {
                  <div>
                    @for (
                      server of storageState.data.outputSftpServers;
                      track server
                    ) {
                      <ng-container
                        *ngTemplateOutlet="
                          sftpServerTemplate;
                          context: {
                            $implicit: 'output',
                            server: server,
                            emoji: '📥',
                          }
                        "></ng-container>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  }
</div>

<!-- SFTP Server Card Template -->
<ng-template
  #sftpServerTemplate
  let-section
  let-server="server"
  let-emoji="emoji">
  <div class="result-card">
    <!-- Server Header -->
    <h3>
      <span class="server-icon">{{ emoji }}</span>
      {{ server.hostName }}
      <span class="server-address">({{ server.address }})</span>
    </h3>

    <!-- Server Error -->
    @if (server.error) {
      <div class="error-message">
        <strong>Error:</strong> {{ server.error }}
      </div>
    }

    <!-- Folders -->
    @if (!server.error && server.folders.length > 0) {
      <div>
        @for (folder of server.folders; track folder) {
          <div class="folder-section">
            <h4 class="folder-title">
              {{ folder.folderType }} Folder
              <span class="folder-path">({{ folder.folderPath }})</span>
            </h4>
            <!-- Folder Error -->
            @if (folder.error) {
              <div class="error-message">
                <strong>Error:</strong> {{ folder.error }}
              </div>
            }
            <!-- Files Table -->
            <ng-container
              *ngTemplateOutlet="
                filesTableTemplate;
                context: {
                  $implicit: section,
                  key: server.address,
                  files: folder.files,
                  error: folder.error,
                }
              "></ng-container>
          </div>
        }
      </div>
    }

    <!-- No Folders -->
    @if (!server.error && server.folders.length === 0) {
      <div class="empty-message">No folders configured for this server</div>
    }

    <!-- Pagination Controls for each Server -->
    <ng-container
      *ngTemplateOutlet="
        paginationTemplate;
        context: {
          $implicit: section,
          key: server.address,
          files: getAllServerFiles(server),
        }
      "></ng-container>
  </div>
</ng-template>

<!-- Search Input Template -->
<ng-template #searchTemplate let-section>
  <div class="search-container">
    <label [for]="'search-' + section" class="sr-only">Search files</label>
    <input
      [id]="'search-' + section"
      type="text"
      class="search-input"
      placeholder="Search files..."
      [value]="getSearchTerm(section)"
      (input)="onSearchChange(section, $any($event).target.value)" />
  </div>
</ng-template>

<!-- Files Table Template -->
<ng-template
  #filesTableTemplate
  let-section
  let-key="key"
  let-files="files"
  let-error="error">
  @if (!error) {
    <div class="table-wrapper">
      @if (files.length === 0) {
        <div class="empty-message">No files in this folder</div>
      }
      @if (files.length > 0) {
        <table class="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Size</th>
              <th>Last Modified</th>
            </tr>
          </thead>
          <tbody>
            @for (
              file of getDisplayedFiles(
                files,
                section,
                key,
                getSearchTerm(section)
              );
              track file
            ) {
              <tr>
                <td class="file-name">{{ file.name }}</td>
                <td>{{ getFileType(file) }}</td>
                <td>
                  {{ file.isDirectory ? '—' : formatFileSize(file.sizeBytes) }}
                </td>
                <td>{{ formatDate(file.lastModified) }}</td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  }
</ng-template>

<!-- Pagination Controls Template -->
<ng-template #paginationTemplate let-section let-key="key" let-files="files">
  <div class="pagination-container">
    <div class="page-size-selector">
      <label [for]="section + '-' + key + '-page-size'">Rows per page:</label>
      <select
        [id]="section + '-' + key + '-page-size'"
        [value]="getPaginationState(section, key)['pageSize']"
        (change)="setPageSize(section, key, +$any($event.target).value)">
        @for (size of PAGE_SIZE_OPTIONS; track size) {
          <option [value]="size">
            {{ size }}
          </option>
        }
      </select>
    </div>

    <div class="pagination-info">
      Page
      {{ getPaginationState(section, key)['currentPage'] }}
      of
      {{ getTotalPages(section, key, files) }}
    </div>

    <div class="pagination-controls">
      <button
        class="pagination-btn"
        [disabled]="!hasPreviousPage(section, key)"
        (click)="goToFirstPage(section, key)"
        aria-label="First page">
        <ng-container *ngTemplateOutlet="firstPageIcon"></ng-container>
      </button>
      <button
        class="pagination-btn"
        [disabled]="!hasPreviousPage(section, key)"
        (click)="goToPreviousPage(section, key)"
        aria-label="Previous page">
        <ng-container *ngTemplateOutlet="prevPageIcon"></ng-container>
      </button>
      <button
        class="pagination-btn"
        [disabled]="!hasNextPage(section, key, files)"
        (click)="goToNextPage(section, key, files)"
        aria-label="Next page">
        <ng-container *ngTemplateOutlet="nextPageIcon"></ng-container>
      </button>
      <button
        class="pagination-btn"
        [disabled]="!hasNextPage(section, key, files)"
        (click)="goToLastPage(section, key, files)"
        aria-label="Last page">
        <ng-container *ngTemplateOutlet="lastPageIcon"></ng-container>
      </button>
    </div>
  </div>
</ng-template>

<!-- Pagination SVG Icons Template -->
<ng-template #firstPageIcon>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2">
    <polyline points="11 17 6 12 11 7"></polyline>
    <polyline points="18 17 13 12 18 7"></polyline>
  </svg>
</ng-template>

<ng-template #prevPageIcon>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2">
    <polyline points="15 18 9 12 15 6"></polyline>
  </svg>
</ng-template>

<ng-template #nextPageIcon>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2">
    <polyline points="9 18 15 12 9 6"></polyline>
  </svg>
</ng-template>

<ng-template #lastPageIcon>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2">
    <polyline points="13 17 18 12 13 7"></polyline>
    <polyline points="6 17 11 12 6 7"></polyline>
  </svg>
</ng-template>
